import { jsxs as l, jsx as C } from "react/jsx-runtime";
const i = ({ size: t = 16, ...L }) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 35 24",
    fill: "none",
    ...L,
    children: [
      /* @__PURE__ */ C("rect", { x: "0.5", y: "0.5", width: "33", height: "23", rx: "5.5", fill: "white", stroke: "#E5E7EB" }),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.80911 9.5C7.99021 9.79741 8.07185 10.1037 8.07185 10.4907C8.07185 11.7249 7.01229 13.3283 6.15234 14.4541H4.18814L3.40039 9.77023L5.12026 9.60786L5.53675 12.9407C5.92592 12.3103 6.40615 11.3196 6.40615 10.6442C6.40615 10.2744 6.34246 10.0226 6.2429 9.81526L7.80911 9.5Z",
          fill: "#459AD9"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10.0378 11.5628C10.3543 11.5628 11.1511 11.4188 11.1511 10.9685C11.1511 10.7523 10.9973 10.6444 10.8161 10.6444C10.4991 10.6444 10.0831 11.0224 10.0378 11.5628ZM10.0015 12.4546C10.0015 13.0044 10.309 13.2202 10.7166 13.2202C11.1605 13.2202 11.5855 13.1123 12.1379 12.8331L11.9298 14.238C11.5406 14.4271 10.9341 14.5533 10.3453 14.5533C8.85188 14.5533 8.31738 13.6527 8.31738 12.5268C8.31738 11.0675 9.18682 9.51807 10.9793 9.51807C11.9662 9.51807 12.518 10.0679 12.518 10.8334C12.5181 12.0676 10.9251 12.4457 10.0015 12.4546Z",
          fill: "#459AD9"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.4814 10.5812C17.4814 10.7613 17.454 11.0226 17.4265 11.1933L16.9105 14.4362H15.2358L15.7066 11.4635C15.7155 11.3829 15.743 11.2206 15.743 11.1305C15.743 10.9143 15.6071 10.8603 15.4438 10.8603C15.2268 10.8603 15.0094 10.9593 14.8645 11.0316L14.3306 14.4362H12.6465L13.4159 9.58114H14.8735L14.8919 9.96866C15.2358 9.7435 15.6886 9.5 16.331 9.5C17.1823 9.49991 17.4814 9.93241 17.4814 10.5812Z",
          fill: "#459AD9"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M22.4533 10.0496C22.9329 9.70762 23.3858 9.51807 24.0102 9.51807C24.8701 9.51807 25.1692 9.95057 25.1692 10.5994C25.1692 10.7795 25.1418 11.0408 25.1145 11.2115L24.599 14.4543H22.9239L23.4037 11.4189C23.4125 11.3377 23.4311 11.2387 23.4311 11.176C23.4311 10.9325 23.2952 10.8785 23.1319 10.8785C22.9239 10.8785 22.7159 10.9686 22.5615 11.0497L22.0277 14.4544H20.353L20.8327 11.4189C20.8415 11.3378 20.8596 11.2388 20.8596 11.176C20.8596 10.9325 20.7236 10.8785 20.5609 10.8785C20.3435 10.8785 20.1265 10.9775 19.9816 11.0498L19.4472 14.4544H17.7637L18.533 9.59934H19.9728L20.0181 10.0047C20.353 9.76176 20.8054 9.51825 21.4119 9.51825C21.9371 9.51807 22.2809 9.74326 22.4533 10.0496Z",
          fill: "#459AD9"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M28.5022 11.4639C28.5022 11.0675 28.4025 10.7973 28.104 10.7973C27.4432 10.7973 27.3074 11.9592 27.3074 12.5535C27.3074 13.0044 27.4343 13.2835 27.7327 13.2835C28.3574 13.2835 28.5022 12.0582 28.5022 11.4639ZM25.6055 12.4818C25.6055 10.9507 26.4201 9.51807 28.2943 9.51807C29.7065 9.51807 30.2228 10.347 30.2228 11.4911C30.2228 13.0044 29.417 14.5716 27.4975 14.5716C26.0762 14.5716 25.6055 13.6437 25.6055 12.4818Z",
          fill: "#459AD9"
        }
      )
    ]
  }
);
export {
  i as VenmoIcon
};
